import { useEffect, useRef } from "react";

import {
    normalizeImageSources,
    preloadImages,
} from "helpers/images/preloadImages";

/**
 * @param {string | Array<string | null | undefined>} sources
 * @param {Object} [options]
 * @param {boolean} [options.enabled=true] skip preloading when false
 * @param {number} [options.concurrency=4] parallel requests
 * @param {boolean} [options.immediate=false] skip idle scheduling
 */
const useImagePreload = (sources, options = {}) => {
    const { enabled = true, concurrency, immediate } = options;

    const normalized = normalizeImageSources(sources);
    const sourceKey = normalized.join("\u0000");

    const sourcesRef = useRef(normalized);
    sourcesRef.current = normalized;

    useEffect(() => {
        if (!enabled || sourceKey === "") {
            return undefined;
        }

        return preloadImages(sourcesRef.current, { concurrency, immediate });
    }, [sourceKey, enabled, concurrency, immediate]);
};

export default useImagePreload;
